import { Component, OnInit } from '@angular/core';

import { TransactionsService } from '../../services/transactions.service'

@Component({
  selector: 'ap-report-ato-quater',
  templateUrl: './ato-quater.component.html',
  styleUrls: ['./ato-quater.component.scss']
})
export class AtoQuaterComponent implements OnInit {

  expenseVATtotal = 0;
  profitVATtotal = 0;
  profitTotal = 0;
  expenseTotal = 0;

  currentQuater = {
    start: new Date("2022-07-01T00:00:00Z"),
    end: new Date("2022-09-30T23:23:59Z")
  }
  
  constructor(private transactionService: TransactionsService) { }

  ngOnInit(): void {

    this.getExpenses();
    this.getRevenue();

  }

  getRevenue () {
    let temp = {};
    let query = {};

    query["source.account"] = "480004229"
    query["ignore"] = { "$in": [null, false] };

    temp["$gte"] = this.currentQuater.start;
    temp["$lte"] = this.currentQuater.end;

    query["date"] = temp;

    this.transactionService.find(query).subscribe(results => {
      for (let i=0;i<results.length;i++) {
        this.profitTotal += results[i].amount;

        if (typeof results[i].vat == "number") {
          this.profitVATtotal += results[i].vat;
        }
      }

      this.profitVATtotal = Math.round(this.profitVATtotal);
    });     
  }

  getExpenses () {
    let temp = {};
    let query = {};

    query["source.account"] = "442829529"
    query["ignore"] = { "$in": [null, false] };

    temp["$gte"] = this.currentQuater.start;
    temp["$lte"] = this.currentQuater.end;

    query["date"] = temp;

    this.transactionService.find(query).subscribe(results => {
      console.log(results);
      for (let i=0;i<results.length;i++) {
        this.expenseTotal += results[i].amount;

        if (typeof results[i].vat == "number") {
          this.expenseVATtotal += results[i].vat;
        }
      }

      this.expenseVATtotal = Math.round(this.expenseVATtotal);
    });
  }

}
